import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons'
import FilePreview from '../FilePreview'

const PreviewModal = ({ open, onClose, src, title, height = 480 }) => {
  return (
    <div className={`modal ${open ? 'modal-open' : ''}`}>
      <div className="modal-box relative max-w-2xl p-0 rounded-card overflow-hidden">
        <div className="flex items-center justify-between gap-3 px-5 py-4 border-b border-line">
          <h3 className="font-semibold text-ink">{title ?? 'Berkas'}</h3>
          <button
            aria-label="Tutup"
            className="w-8 h-8 rounded-lg border border-line text-muted hover:bg-subtle hover:text-ink transition-colors"
            onClick={onClose}
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>
        <div className="p-5 bg-subtle flex justify-center">
          <FilePreview src={src} height={height} width={height} />
        </div>
      </div>
    </div>
  )
}

export default PreviewModal
